<template>


<md-list class="md-double-line" id="ql-sidenav-layer-list">
    <md-dialog-confirm
        :md-title="'Confirm Layer Delete'"
        :md-content-html="'This layer contains cues. Are you sure you want to delete it?'"
        :md-ok-text="'Yes'"
        :md-cancel-text="'Cancel'"
        @close="dialogClose"
        ref="deleteLayerDialog">
    </md-dialog-confirm>
    <layer v-for="layer in getAllLayers"
        :layer="layer"  
        :key="layer.id"
        :viewable="canView(layer)"
        :viewableLayer="canViewLayer(layer)"
        :editable="canEdit(layer)"
        :layerTitleFontSize="getTitleFontSize(layer)"
        :layerDefaultCuePlacement="getDefaultCuePlacementPrint(layer.id)"
        :layerLineOpacity="getCueLineOpacity({layer: layer.id})"
        :layerCueBoxOpacity="getLayerBoxOpacity({layer: layer.id})"
        :layerAutoNumbering="getLayerAutoNumbering(layer.id)"
        :layerAutoNumberStart="getLayerAutoNumberStart(layer.id)"
        :layerAutoNumberInterval="getLayerAutoNumberInterval(layer.id)"
        :showNotes="canShowNotes(layer)"
        :showCues="canShowCues(layer)"
        :headerBox="getHeaderBox(layer)"
        :userDefined="getUserDefined(layer)"
        @deleteLayer="tryDeleteLayer"
        @close="emitClose"
    />
</md-list>
</template>

<script>

import { mapGetters } from 'vuex';
import LayersLayer from '@/components/layers/layer';

const LayersNav = {
    name: 'CoreHeader',
    props: [],
    data: function() {
        return {
            newLayerTitle: '',
            layerToDelete: null
        };
    },
    components: {
        layer: LayersLayer
    },
    computed: {
        ...mapGetters([
            'userProjectData',
            'userProjectByUidData',
            'layers',
            'visibleLayerIDs',
            'showNotesLayerIDs',
            'showCuesLayerIDs',
            'editableLayers',
            'cuesPerLayer',
            'cuePlacement',
            'getDefaultCuePlacementPrint',
            'getLayerBoxOpacity',
            'getCueLineOpacity',
            'getLayerAutoNumbering',
            'getLayerAutoNumberStart',
            'getLayerAutoNumberInterval'
        ]),
        getAllLayers() {
            return this.layers;
        }
    },
    methods: {
        emitClose() {
            this.$emit('close');
        },
        canView(layer) {
            const layerIDs = this.showCuesLayerIDs;
            return layerIDs.includes(layer.id);
        },
        canViewLayer(layer) {
            const layerIDs = this.visibleLayerIDs;
            return layerIDs.includes(layer.id);
        },
        canEdit(layer) {
            const layerIDs = this.editableLayers.map(l => l.id);
            return layerIDs.includes(layer.id);
        },
        canShowNotes(layer) {
            return this.showNotesLayerIDs && this.showNotesLayerIDs.includes(layer.id);
        },
        canShowCues(layer) {
            return this.showCuesLayerIDs && this.showCuesLayerIDs.includes(layer.id);
        },
        getTitleFontSize(layer) {
            const layers = this.userProjectData.layers;
            if (layers && layers[layer.id]) {
                if (layers[layer.id].titleFontSize) {
                    return layers[layer.id].titleFontSize;
                }
            }
            return 14;
        },
        getBoxOpacity(layer) {
            if (layer && layer.boxOpacity) {
                return layer.boxOpacity;
            }
            return 20;
        },
        getLineOpacity(layer) {
            if (layer && layer.lineOpacity) {
                return layer.lineOpacity;
            }
            return 30;
        },
        getHeaderBox(layer) {
            const layers = this.userProjectData.layers;
            if (layers && layers[layer.id]) {
                if (layers[layer.id].headerBox) {
                    return {
                        layerName: true,
                        ...layers[layer.id].headerBox
                    };
                }
            }
            return {
                title: true,
                label: true,
                time: false,
                layerName: true
            };
        },
        getUserDefined(layer) {
            if (layer && layer.userDefined && (layer.userDefined.user1 || layer.userDefined.user2 || layer.userDefined.user3 || layer.userDefined.user4)) {
                return layer.userDefined;
            }
            
            return {
                user1: { label: '', value: false },
                user2: { label: '', value: false },
                user3: { label: '', value: false },
                user4: { label: '', value: false }
            };
        },
        hideLayer() {
        },
        showLayer() {
        },
        updateLayer() {
        },
        dialogClose(type) {
            if (type === 'cancel') {
                this.layerToDelete = null;
            } 
            if (type === 'ok') {
                this.deleteLayer();
            }
        },
        tryDeleteLayer(layer) {
            const numCues = this.cuesPerLayer(layer.id).length;
            this.layerToDelete = layer;
            if (numCues === 0) {
                this.deleteLayer();
            } else {
                this.$refs.deleteLayerDialog.open();
            }
        },
        deleteLayer() {
            if (this.layerToDelete) {
                this.$store.dispatch('removeLayer', this.layerToDelete);
            }
        }
    }
};
export default LayersNav;

</script>


// WEBPACK FOOTER //
// layer-list.vue?4596fdab